// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer___Y61l","bottom":"footer_bottom__35qyD","runlogo":"footer_runlogo__11-x5","link":"footer_link__7fpVd"};